Parsley.addMessages('custom', {
    defaultMessage: translations.parsley.defaultMessage,
    type: {
        email: translations.parsley.email,
        url: translations.parsley.url,
        number: translations.parsley.number,
        integer: translations.parsley.integer,
        digits: translations.parsley.digits,
        alphanum: translations.parsley.alphanum
    },
    notblank: translations.parsley.notblank,
    required: translations.parsley.required,
    pattern: translations.parsley.pattern,
    min: translations.parsley.min,
    max: translations.parsley.max,
    range: translations.parsley.range,
    minlength: translations.parsley.minlength,
    maxlength: translations.parsley.maxlength,
    length: translations.parsley.length,
    mincheck: translations.parsley.mincheck,
    maxcheck: translations.parsley.maxcheck,
    check: translations.parsley.check,
    equalto: translations.parsley.equalto,
    phoneFormat: translations.parsley.phoneFormat,
    emailFormat: translations.parsley.emailFormat
});

Parsley.setLocale('custom');